export default __webpack_public_path__ + "static/media/red-gown-girl.008d1585.jpg";